var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12.5,
    fill: "#26282F",
    stroke: "#363943"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_7)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3753 16.8984C14.4451 16.9597 14.5384 16.994 14.6356 16.994C14.7328 16.994 14.8262 16.9597 14.896 16.8984C14.9303 16.8682 14.9575 16.832 14.9761 16.7921C14.9947 16.7522 15.0043 16.7093 15.0043 16.6659C15.0043 16.6226 14.9947 16.5797 14.9761 16.5398C14.9575 16.4999 14.9303 16.4637 14.896 16.4335L10.9776 12.9351L14.8948 9.55783C14.929 9.52776 14.9561 9.49181 14.9746 9.45207C14.9931 9.41233 15.0027 9.36963 15.0027 9.32649C15.0027 9.28335 14.9931 9.24065 14.9746 9.20091C14.9561 9.16117 14.929 9.12519 14.8948 9.09512C14.8256 9.0328 14.732 8.99784 14.6345 8.99784C14.5369 8.99784 14.4433 9.0328 14.3741 9.09512L9.99571 12.9351L14.3753 16.8984Z",
    fill: "#8D8E92"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 8,
    fill: "white",
    transform: "matrix(-1 0 0 1 15 9)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.0177ff72331ef6770d012dfaa376a289.svg";
export { ForwardRef as ReactComponent };